var klaviyo = klaviyo || [];
klaviyo.init({
  account: "NVfALU",
  platform: "shopify"
});
klaviyo.enable("backinstock",{ 
trigger: {
  product_page_text: "Meddela mig när denna produkt finns tillgänglig",
  product_page_class: "add-to-cart",
  product_page_text_align: "center",
  product_page_margin: "0px",
  replace_anchor: true
},
modal: {
 headline: "{product_name}",
 body_content: "Registrera dig för att få en avisering när denna vara är tillbaka i lager.",
 email_field_label: "E-postadress",
 button_label: "Meddela mig när varan finns i lager.",
 subscription_success_label: "Tack! Vi kommer att meddela dig när denna produkt blir tillgänglig.",
 footer_content: '',
 additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
 drop_background_color: "#000",
 background_color: "#fff",
 text_color: "#222",
 button_text_color: "#fff",
 button_background_color: "#5e8671",
 close_button_color: "#ccc",
 error_background_color: "#fcd6d7",
 error_text_color: "#C72E2F",
 success_background_color: "#d3efcd",
 success_text_color: "#1B9500"
}
});